// 右上コントロール（参加者一覧・共有タイマー）の実測幅を CSS 変数
// `--canvas-top-right-width` へ反映する。
//
// 左上のアプリメニューは、右上コントロールの下に潜って押せなくなるのを避けるため、
// 折り返し幅の上限からこの幅を差し引いている。差し引き量を「最大構成の見積もり」で
// 固定すると、参加者が少なく実際の右上コントロールが狭い場合でも同じだけ引かれてしまい、
// 画面幅に余裕があるのにアプリメニューが折り返してしまう。実測値を渡すことで、
// 折り返しを「本当に幅が足りないとき」だけに限定する。
//
// 参加者の増減やタイマー表示の変化で幅が変わるため、ResizeObserver で追従する。
//
// 同じ仕組みをアプリメニューの高さ・下部ツールバーの幅でも使うため、実装は汎用フック
// usePanelSizeReserve へ寄せ、ここはその薄いラッパーとして残す（呼び出し側から見た契約は不変）。

import { type RefObject } from "react";
import { TOP_RIGHT_WIDTH_VARIABLE, usePanelSizeReserve } from "./use-panel-size-reserve";

export function useTopRightReserve(ref: RefObject<HTMLElement | null>): void {
  usePanelSizeReserve(ref, TOP_RIGHT_WIDTH_VARIABLE, "width");
}
